import React, { useContext } from 'react';
import { AsyncSelect, ValueType, ActionMeta } from '@atlaskit/select';
import { SelectValueLabel, UserWithAvatar } from './UserWithAvatar';
import { GlobalContext } from '../../shared-components/common/GlobalContext';
import { DTOUserSearchResultItem, ErrorOrPayload, GET_USER_PICKER_QUERY } from '../../generated-common';

export const CCUserPicker = ({
  onUserPicked,
  alreadyAssignedUserAccountIds,
  isMutating,
}: {
  onUserPicked: (userAccountId: string) => void;
  alreadyAssignedUserAccountIds: string[];
  isMutating: boolean;
}) => {
  const { t, handleRestError, invoke } = useContext(GlobalContext);
  return (
    <AsyncSelect
      formatOptionLabel={(option: SelectValueLabel, { context }: { context: any }) => {
        if (context === 'menu') {
          // const inUseData = isUserUsedAlready(option.value);
          const isDisabled = false; // FIXME; (usedIn === 'global' && inUseData.global === true) || (usedIn === 'context' && contextId && inUseData.context.indexOf(contextId) !== -1);
          return (
            <>
              <UserWithAvatar isDisabled={isDisabled ? isDisabled : false} parentWidth={500} user={option} index={-1} isReadOnly={true} onDelete={() => {}} />
            </>
          );
        }
        return option.label;
      }}
      loadOptions={(searchText: any, callback: Function) => {
        invoke(GET_USER_PICKER_QUERY, { query: searchText }).then((errorOrPayload: null | ErrorOrPayload<DTOUserSearchResultItem[]>) => {
          handleRestError(errorOrPayload, GET_USER_PICKER_QUERY);
          const usersToDisplay: any[] = [];
          if (errorOrPayload && errorOrPayload.payload) {
            for (const foundUser of errorOrPayload.payload) {
              usersToDisplay.push({
                value: foundUser.accountId,
                label: foundUser.displayName,
                displayName: foundUser.displayName,
                avatar: foundUser.avatarUrl,
              });
            }
          }
          callback(usersToDisplay);
        });
      }}
      isClearable={false}
      isSearchable={true}
      isDisabled={isMutating}
      isOptionDisabled={(_option: SelectValueLabel) => {
        return alreadyAssignedUserAccountIds.includes(_option.value);
      }}
      value={null}
      placeholder={t('editPermissionsPage.placeholders.userPermissions')}
      noOptionsMessage={() => t('editPermissionsPage.placeholders.typeToSeeUsers')}
      onChange={(value: ValueType<SelectValueLabel, false>, action: ActionMeta<SelectValueLabel>) => {
        if (value && value.value) {
          onUserPicked(value.value);
        }
      }}
    />
  );
};
